/**
 * The browser tab: the survey's title and the organisation's logo as icon, so a participant with
 * several tabs finds the right one. The logo is a data URI like everywhere else (CSP, SPEC §12).
 */
export function setPageIdentity(title: string, logo?: string) {
  document.title = title;
  const icon = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
  if (icon && logo) icon.href = logo;
}

/** The trust page of a survey, in the language the participant reads in (the page passes it on as `?lang=`). */
export const trustHref = (slug: string, locale: string) => `/trust/${encodeURIComponent(slug)}?lang=${encodeURIComponent(locale)}`;
